module.exports = __webpack_public_path__ + "media/124.482ef9b5.mp3";